import React, { useEffect, useState } from "react";
import { Services } from "../../api/Services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL_COMPETITION } from "../../api/Constants";

const Progress = ({ activeId }) => {
  //current last date
  const currentDate = new Date();
  const lastDate = currentDate.toISOString().split("T")[0];
  //Month start date

  const thirtyDaysBeforeDate = new Date();
  thirtyDaysBeforeDate.setDate(thirtyDaysBeforeDate.getDate() - 29);

  const monthstartDate = thirtyDaysBeforeDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  //60days start date

  const sixtyDaysBeforeDate = new Date();
  sixtyDaysBeforeDate.setDate(sixtyDaysBeforeDate.getDate() - 59);

  const sixtystartDate = sixtyDaysBeforeDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  //nintydays start date

  const nintyDaysBeforeDate = new Date();
  nintyDaysBeforeDate.setDate(nintyDaysBeforeDate.getDate() - 89);

  const nintystartDate = nintyDaysBeforeDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  const [isLoading, setIsLoading] = useState(false);
  const [exerciseList, setExerciseList] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [activeDate, setActiveDate] = useState("all");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [exerciseId, setExerciseId] = useState("");
  const [exerciseStatsList, setExerciseStatsList] = useState([{}]);
  const [custom, setCustom] = useState(false);
  const [show, setShow] = useState(false);
  const [singleModal, setSingleModal] = useState(false);

  const setMonth = () => {
    setDateFrom(monthstartDate);
    setDateTo(lastDate);
    setActiveDate("monthly");
  };
  const setAll = () => {
    setDateFrom("");
    setDateTo("");
    setActiveDate("all");
  };
  const setTwoMonths = () => {
    setDateFrom(sixtystartDate);
    setDateTo(lastDate);
    setActiveDate("sixtydays");
  };
  const setThreeMonths = () => {
    setDateFrom(nintystartDate);
    setDateTo(lastDate);
    setActiveDate("nintydays");
  };
  const setCustomDate = () => {
    setActiveDate("custom");
    setCustom(true);
  };

  //set single excercise data

  //api call for get trainer exercise
  const getExercises = async (id, datefrom, dateto, keyword) => {
    setIsLoading(true);
    try {
      const result = await Services.getTarinerExercises(
        id,
        datefrom,
        dateto,
        keyword
      );

      if (result) {
        setIsLoading(false);
        setExerciseList(result?.data?.data);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getExercises(
      activeId,
      dateFrom ? dateFrom : "",
      dateTo ? dateTo : "",
      keyword
    );
  }, [activeId, dateFrom, dateTo, keyword]);

  //Api call for exercise stats
  const getExerciseStats = async (exid, datefrom, dateto, activeId) => {
    setIsLoading(true);
    try {
      const result = await Services.getTarinerExerciseStats(
        exid,
        datefrom,
        dateto,
        activeId
      );

      if (result) {
        setShow(true);
        setIsLoading(false);
        setExerciseStatsList(result?.data?.data);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  //   useEffect(()=>{
  //     getExerciseStats(dateFrom,dateTo,exerciseId,activeDate)
  //   },[dateFrom,dateTo,exerciseId,activeDate])
  const excerciseDetails = (id) => {
    setShow(false);
    setExerciseId(id);

    getExerciseStats(
      id,
      dateFrom ? dateFrom : "",
      dateTo ? dateTo : "",
      activeId
    );
  };
  return (
    <div className="progress-wrapper">
      {isLoading && (
        <div className="loaderparent">
          <div className="loader"></div>
        </div>
      )}
      {singleModal && (
        <div className="trainer-modal-eventWrapper">
          <div className="trainer-modal">
            <div className="closee">
              <i
                className="fa fa-times"
                onClick={() => setSingleModal(false)}
              ></i>
            </div>
            <div className="trainer_childd">
              <div class="accordion" id="accordionExample">
                {exerciseStatsList?.map((ex, id) =>
                  ex?.progress?.length > 0 ? (
                    <div>
                      {" "}
                      <h2 className="titlee">{ex?.name}</h2>{" "}
                      {ex?.progress?.map(
                        (pro, childid) =>
                          pro.value > 0 && (
                            <div class="accordion-item">
                              <h2 class="accordion-header" id="headingOne">
                                <button
                                  class="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#test${id}${childid}`}
                                  aria-expanded="true"
                                  aria-controls="collapseOne"
                                >
                                  <span className="datee"> {pro?.date} </span>
                                  <span>
                                    <span className="valuee">{pro?.value}</span>{" "}
                                    <span className="unitt">{pro?.unit}</span>
                                  </span>
                                </button>
                              </h2>
                              <div
                                id={`test${id}${childid}`}
                                class="accordion-collapse collapse"
                                aria-labelledby="headingOne"
                                data-bs-parent="#accordionExample"
                              >
                                <div class="accordion-body">
                                  <hr className="my-2" />
                                  <div className="header-body">
                                    <span>Sets</span>
                                    <span>Workout</span>
                                    <span>Value</span>
                                  </div>
                                  {pro?.sets?.map((set, index) => (
                                    <div className="body-item" key={index}>
                                      <span>{index + 1}</span>
                                      <span>{set?.workout_name}</span>
                                      <span>{set?.set_value}</span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )
                      )}{" "}
                    </div>
                  ) : (
                    ""
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="monthly-stats mb-4">
        <button
          className={`${activeDate == "all" ? "active" : ""}`}
          onClick={() => setAll()}
        >
          All days
        </button>
        <button
          className={`${activeDate == "monthly" ? "active" : ""}`}
          onClick={() => setMonth()}
        >
          30 days
        </button>
        <button
          className={`${activeDate == "sixtydays" ? "active" : ""}`}
          onClick={() => setTwoMonths()}
        >
          60 days
        </button>
        <button
          className={`${activeDate == "nintydays" ? "active" : ""}`}
          onClick={() => setThreeMonths()}
        >
          90 days
        </button>
        <div className="relativ">
          <button
            className={`${activeDate == "custom" ? "active custom" : "custom"}`}
            onClick={() => setCustomDate()}
          >
            Custom{" "}
          </button>
          {custom && (
            <div className="dropdown">
              <div className="child">
                <label htmlFor="">Date from</label>
                <input
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </div>
              <div className="child">
                <label htmlFor="">Date to</label>
                <input
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </div>

              <div className="d-flex justify-content-center">
                <button className="button" onClick={() => setCustom(false)}>
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="row">
        {exerciseList?.map((program) => (
          <div className="col-12 col-md-6">
            <div className="program_item">
              <div
                className="pointer"
                onClick={() => excerciseDetails(program?.exercise_id)}
              >
                <p className="title">
                  {program?.name} {program?.exercise_id}
                </p>
                <div className="d-flex justify-content-between pointer">
                  <div className="items">
                    <i class="fa-regular fa-circle-check"></i>{" "}
                    <span className="count">{program?.times_performed}</span>{" "}
                    <span>Times Performed</span>
                  </div>
                  {exerciseId == program?.exercise_id && show ? (
                    ""
                  ) : (
                    <i class="fa-solid fa-chevron-down"></i>
                  )}
                </div>
              </div>
              {exerciseId == program?.exercise_id && show ? (
                <div className="exercise_stats_wrapper">
                  <div className="close" onClick={() => setShow(false)}>
                    <i class="fa-solid fa-chevron-up"></i>
                  </div>
                  {exerciseStatsList?.map((ex) => (
                    <div className="itemm">
                      <div className="items">
                        <i class="fa-regular fa-circle-check"></i>
                        <div className="count">
                          {parseFloat(ex?.progress_total?.toFixed(2))}
                          <sub>{ex?.unit}</sub>
                        </div>
                      </div>
                      <p className="name">{ex?.name}</p>

                      <button
                        className="view_deatil"
                        onClick={() => setSingleModal((pre) => !pre)}
                      >
                        View Detail
                      </button>
                      {console.log("singleExercise", exerciseStatsList)}
                    </div>
                  ))}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Progress;
